import { safeStr } from "common/api";

export const expressDestination = (destination = null) =>
  destination !== null
  ? `ip-internet ${destination}`
  : 'all-internet';

export const expressCategory = service =>
  service === "all-average" ? "all" : `category ${safeStr(service)}`;
